import { render, staticRenderFns } from "./TheContact.vue?vue&type=template&id=3b9cd541&scoped=true&"
import script from "./TheContact.vue?vue&type=script&lang=js&"
export * from "./TheContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9cd541",
  null
  
)

export default component.exports